"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var overrideFileUrls = function overrideFileUrls(file, url) {
  return file.merge({
    url: url,
    friendly_url: url,
    alt_url: url,
    default_hosting_url: url
  });
};

var _default = overrideFileUrls;
exports.default = _default;
module.exports = exports.default;